var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
 * This is essentially a mock Router built using Context. It's meant to match
 * the react-router-dom API in order to limit the scope of this change.
 *
 * TODO: Replace this with a complete API that can support next/router & react-router-dom
 * https://jira.cvent.com/browse/CARINA-1203
 */
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
function createCtx() {
    var ctx = createContext(undefined);
    var useCtx = function () {
        var c = useContext(ctx);
        if (c === undefined)
            throw new Error('useWizardRouter must be inside a WizardRouterProvider with a value');
        return c;
    };
    return [useCtx, ctx.Provider]; // 'as const' makes TypeScript infer a tuple
}
var _a = __read(createCtx(), 2), useWizardRouter = _a[0], WizardRouterProvider = _a[1];
export { useWizardRouter, WizardRouterProvider };
export var useHistory = function () {
    var _a = useWizardRouter(), _step = _a.step, router = __rest(_a, ["step"]);
    return __assign({}, router);
};
export var useLocation = function () {
    var _a = useWizardRouter(), step = _a.step, entries = _a.entries;
    return { pathname: entries[step].pathname };
};
export var Router = function (_a) {
    var children = _a.children, _b = _a.initialEntries, initialEntries = _b === void 0 ? [] : _b, _c = _a.initialIndex, initialIndex = _c === void 0 ? 0 : _c;
    var _d = __read(useState(initialEntries), 1), steps = _d[0];
    var _e = __read(useState(initialIndex), 2), step = _e[0], setStep = _e[1];
    /** begin react-router-dom interface */
    var canGo = useCallback(function (index) { return index >= 0 && index < steps.length; }, [steps]);
    var entries = useMemo(function () { return steps.map(function (pathname) { return ({ pathname: pathname }); }); }, [steps]);
    var go = useCallback(function (index) { return canGo(index) && setStep(index); }, [
        canGo,
        setStep
    ]);
    var goBack = useCallback(function () {
        setStep(function (s) { return Math.max(0, s - 1); });
    }, [setStep]);
    var goForward = useCallback(function () {
        setStep(function (s) { return Math.min(steps.length - 1, s + 1); });
    }, [steps, setStep]);
    /** end react-router-dom interface */
    return (_jsx(WizardRouterProvider, __assign({ value: { canGo: canGo, entries: entries, go: go, goBack: goBack, goForward: goForward, step: step } }, { children: children }), void 0));
};
export var Route = function (_a) {
    var children = _a.children, path = _a.path;
    var pathname = useLocation().pathname;
    return path === pathname ? children : null;
};
export var WizardRouter = function (_a) {
    var children = _a.children, initialStep = _a.initialStep, initialSteps = _a.initialSteps;
    return (_jsx(Router, __assign({ initialIndex: initialSteps.indexOf(initialStep), initialEntries: initialSteps }, { children: children }), void 0));
};
